import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';

@Component({
    selector: 'app-ot-transport-details',
    templateUrl: './ot-transport-details.component.html',
    styleUrls: ['./ot-transport-details.component.scss'],
    standalone: false
})
export class OtTransportDetailsComponent implements OnInit {

  activeSlideIndex = 0;
  myInterval = 1500;
  showIndicator: boolean = false
  subscription: Subscription;
  haSubscription: Subscription
  otList: any;
  patientDetails: any;
  key: any;

  constructor(
    public baseService: BaseService,
    public authenticationService: AuthenticationService
  ) {

  }

  onSlideChange(event: any) {
    if(event == undefined){
      this.activeSlideIndex = 0;
    }else{
      this.activeSlideIndex = event;
    }
  }

  ngOnInit(): void {
    this.key = this.authenticationService.getEnryptionKey();
    this.baseService.get("GET_USER_OT", "type:ot", "ot_user_mapping", "ot").subscribe((res: any) => {
      if (res.errCode == 0) {
        this.otList = res.resource;
        this.getOTPatient(res.resource);
      }
    });
  }
  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
    this.haSubscription && this.haSubscription.unsubscribe();
    let showbody: HTMLElement = document.getElementsByTagName("body")[0] as HTMLElement
    showbody.style.background = "white";
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = null;
    hasColor.style.width = null;
    // let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    // hasDisplay.style.display = "block";
    setTimeout(function () {
      let hideSidebar: HTMLElement = document.getElementsByClassName("navbar-toggler")[1] as HTMLElement;
      hideSidebar.click();
    }, 5)
  }

  getOTPatient(data: any) {
    let args: any = "";
    for (let i = 0; i < data.length; i++) {
      args += data[i].name + '!';
    }
    args = "otName:" + args;
    args = args.substring(0, args.length - 1)
    this.baseService.get("GET_OT_CURRENT_DETAILS", args, "surgery_request", "ot").subscribe((res: any) => {
      if (res.errCode == 0) {
        this.patientDetails = res.resource
      }
    });
  }


  calculateStyles(_hasLength: any) {
    return { 'width': (100 / _hasLength) + "%" }
  }
  ngAfterViewInit() {
    setTimeout(function () {
      let hideSidebar: HTMLElement = document.getElementsByClassName("navbar-toggler")[1] as HTMLElement;
      hideSidebar.click();
    }, 5)
  }
}
